import React from 'react';
import { hasFinePointer } from '../utils/letterPicking';
import './Game.css';

export function lettersLabel(count) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return `${count} буква`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${count} буквы`;
  return `${count} букв`;
}

/** Text field + backspace + submit, shared by every word game. */
function GuessInput({
  value,
  length,
  onChange,
  onBackspace,
  onSubmit,
  inputRef,
  shake = false,
  message = '',
  disabled = false,
  submitLabel = 'Угадать',
  showSubmit = true,
  children
}) {
  return (
    <form onSubmit={onSubmit} className="guess-form">
      <div className="input-group">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={lettersLabel(length)}
          maxLength={length}
          className={`field guess-input${shake ? ' guess-input--shake' : ''}`}
          autoComplete="off"
          autoCapitalize="characters"
          inputMode="text"
          enterKeyHint="done"
          autoFocus={hasFinePointer()}
          aria-invalid={Boolean(message)}
          disabled={disabled}
        />
        <button
          type="button"
          className="btn btn-secondary guess-backspace"
          onClick={onBackspace}
          disabled={disabled || !value}
          aria-label="Удалить последнюю букву"
          title="Удалить"
        >
          ←
        </button>
      </div>
      {showSubmit && (
        <button
          type="submit"
          className="btn btn-primary guess-submit"
          disabled={disabled || !value || value.trim().length !== length}
        >
          {submitLabel}
        </button>
      )}
      {message && <div className="alert alert-error">{message}</div>}
      {children}
    </form>
  );
}

export default GuessInput;
